import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['quantityInput', 'allCheckbox'];

  quantityInputTarget: HTMLInputElement;

  allCheckboxTarget: HTMLInputElement;

  toggleEditableState() {
    if (this.allCheckboxTarget.checked) {
      this.deactivateEditableState();
    } else {
      this.activateEditableState();
    }
  }

  toggleEditableStateFromInput() {
    if (this.allCheckboxTarget.checked) {
      this.activateEditableState();
    }
  }

  private activateEditableState() {
    this.allCheckboxTarget.checked = false;
    this.quantityInputTarget.focus();
    this.quantityInputTarget.value = this.totalShares;
    this.quantityInputTarget.disabled = false;
    this.quantityInputTarget.classList.remove('u-backgroundColor-bmtGrey10');
  }

  private deactivateEditableState() {
    this.allCheckboxTarget.checked = true;
    this.quantityInputTarget.value = '';
    this.quantityInputTarget.disabled = true;
    this.quantityInputTarget.classList.add('u-backgroundColor-bmtGrey10');
  }

  get totalShares() {
    return this.data.get('totalShares') || '';
  }
}
